(function(){
  'use strict';

  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }

  function localeKey(){
    return (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  }

  var copy={
    en:{one:'traveler',many:'travelers',edit:'Edit travelers'},
    pt:{one:'viajante',many:'viajantes',edit:'Editar viajantes'},
    es:{one:'viajero',many:'viajeros',edit:'Editar viajeros'},
    fr:{one:'voyageur',many:'voyageurs',edit:'Modifier les voyageurs'},
    de:{one:'Reisender',many:'Reisende',edit:'Reisende bearbeiten'},
    it:{one:'viaggiatore',many:'viaggiatori',edit:'Modifica viaggiatori'},
    nl:{one:'reiziger',many:'reizigers',edit:'Reizigers aanpassen'},
    ar:{one:'مسافر',many:'مسافرين',edit:'تعديل المسافرين'},
    he:{one:'נוסע',many:'נוסעים',edit:'עריכת נוסעים'}
  };

  function initCard(card){
    if(!card || card.dataset.pmyConversionReady==='1') return;
    card.dataset.pmyConversionReady='1';

    var list=card.querySelector('.tickets-open-list');
    var rows=list ? Array.prototype.slice.call(list.querySelectorAll('.passenger-row')) : [];
    var t=copy[localeKey()] || copy.en;

    if(list && rows.length){
      var toggle=document.createElement('button');
      toggle.type='button';
      toggle.className='pmy-travelers-toggle';
      toggle.setAttribute('aria-expanded','false');
      toggle.setAttribute('aria-label',t.edit);
      toggle.innerHTML='<span class="pmy-travelers-toggle__summary"><span class="pmy-travelers-toggle__icon" aria-hidden="true">♙</span><span data-pmy-travelers-summary></span></span><span class="pmy-travelers-toggle__chevron" aria-hidden="true"></span>';
      list.parentNode.insertBefore(toggle,list);
      card.classList.add('pmy-travelers-collapsed');

      var summary=toggle.querySelector('[data-pmy-travelers-summary]');
      function currentCount(){
        var total=0;
        rows.forEach(function(row){
          var node=row.querySelector('.qty-num');
          var value=parseInt(node ? node.textContent : '0',10);
          if(Number.isFinite(value)) total+=value;
        });
        return total;
      }
      function updateSummary(){
        var count=currentCount();
        summary.textContent=count+' '+(count===1?t.one:t.many);
      }
      function setExpanded(expanded){
        toggle.setAttribute('aria-expanded',expanded?'true':'false');
        card.classList.toggle('pmy-travelers-collapsed',!expanded);
        updateSummary();
      }
      toggle.addEventListener('click',function(){
        setExpanded(toggle.getAttribute('aria-expanded')!=='true');
      });
      list.addEventListener('click',function(event){
        if(event.target.closest('.qty-btn')) window.setTimeout(updateSummary,0);
      });
      var observer=new MutationObserver(updateSummary);
      rows.forEach(function(row){
        var qty=row.querySelector('.qty-num');
        if(qty) observer.observe(qty,{childList:true,subtree:true,characterData:true});
      });
      updateSummary();
    }

    var form=card.querySelector('.booking-form') || card;
    var total=form.querySelector('#total-price-wrapper');
    var cta=form.querySelector('.btn-verify-pmy');
    if(total && cta && !form.querySelector('.pmy-booking-bottom')){
      var bottom=document.createElement('div');
      bottom.className='pmy-booking-bottom';
      total.parentNode.insertBefore(bottom,total);
      bottom.appendChild(total);
      bottom.appendChild(cta);
    }

    var sidebar=card.closest('.pdp-sidebar');
    if(sidebar){
      sidebar.style.removeProperty('transform');
    }
  }

  ready(function(){
    document.body.classList.add('template-product');
    document.querySelectorAll('.checkout-card').forEach(initCard);

    document.addEventListener('shopify:section:load',function(event){
      var scope=event.target || document;
      scope.querySelectorAll('.checkout-card').forEach(initCard);
    });
  });
})();

(function(){
  'use strict';

  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }

  function injectStyles(){
    if(document.getElementById('pmy-pdp-mobile-refinement')) return;
    var style=document.createElement('style');
    style.id='pmy-pdp-mobile-refinement';
    style.textContent=`
      @media (max-width: 767px) {
        body.template-product .pdp-page-header {
          margin-bottom: 14px !important;
        }

        body.template-product .pdp-breadcrumb {
          font-size: 13px !important;
          line-height: 1.25 !important;
          margin-bottom: 8px !important;
          opacity: .64 !important;
          font-weight: 500 !important;
        }

        body.template-product .pdp-title {
          font-size: clamp(26px, 7vw, 30px) !important;
          line-height: 1.09 !important;
          letter-spacing: -.45px !important;
          font-weight: 800 !important;
          max-width: 100% !important;
          margin: 0 !important;
          text-wrap: balance;
        }

        body.template-product .pdp-share-wrapper {
          justify-content: flex-start !important;
          margin-top: 12px !important;
          margin-bottom: 16px !important;
        }

        body.template-product .btn-share-tour {
          text-decoration: none !important;
          text-underline-offset: 0 !important;
          font-size: 13px !important;
          line-height: 1 !important;
          gap: 6px !important;
          padding: 8px 12px !important;
          border-radius: 999px !important;
          border: 1px solid rgba(0, 102, 0, .12) !important;
          background: rgba(255, 255, 255, .42) !important;
          box-shadow: 0 4px 14px rgba(0, 0, 0, .04) !important;
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
        }

        body.template-product .btn-share-tour svg {
          width: 16px !important;
          height: 16px !important;
        }

        body.template-product .pdp-gallery-grid {
          display: flex !important;
          flex-direction: row !important;
          flex-wrap: nowrap !important;
          width: 100% !important;
          gap: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow-x: auto !important;
          overflow-y: hidden !important;
          scroll-snap-type: x mandatory !important;
          scroll-padding-inline: 0 !important;
          border-radius: 18px !important;
          scrollbar-width: none !important;
          background: rgba(255, 255, 255, .18) !important;
          overscroll-behavior-x: contain;
        }

        body.template-product .pdp-gallery-grid::-webkit-scrollbar {
          display: none !important;
        }

        body.template-product .pdp-gallery-grid .gallery-item {
          flex: 0 0 100% !important;
          width: 100% !important;
          min-width: 100% !important;
          height: clamp(260px, 70vw, 305px) !important;
          scroll-snap-align: start !important;
          scroll-snap-stop: always !important;
          border-radius: 18px !important;
          overflow: hidden !important;
          transform: none !important;
        }

        body.template-product .pdp-gallery-grid .gallery-item .media-content {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover !important;
          object-position: center center !important;
        }

        body.template-product .pmy-gallery-dots-container {
          margin-top: 10px !important;
          margin-bottom: 10px !important;
          gap: 5px !important;
        }

        body.template-product .pmy-dot {
          width: 5px !important;
          height: 5px !important;
          background: rgba(0,0,0,.18) !important;
        }

        body.template-product .pmy-dot.active {
          width: 18px !important;
          border-radius: 999px !important;
          background: var(--pmy-btn-bg) !important;
        }

        body.template-product .btn-see-all-mobile {
          margin-top: 4px !important;
        }
      }

      .pmy-share-layer {
        position: fixed;
        inset: 0;
        z-index: var(--pmy-z-overlay);
        display: none;
      }

      .pmy-share-layer.is-open {
        display: block;
      }

      .pmy-share-backdrop {
        position: absolute;
        inset: 0;
        background: rgba(17, 25, 18, .28);
        backdrop-filter: blur(3px);
        -webkit-backdrop-filter: blur(3px);
      }

      .pmy-share-sheet {
        position: fixed;
        left: 14px;
        right: 14px;
        bottom: 14px;
        background: rgba(255,255,255,.96);
        border: 1px solid rgba(0,102,0,.10);
        border-radius: 24px;
        box-shadow: 0 24px 70px rgba(19, 45, 25, .22);
        padding: 16px 16px 18px;
        color: #173d22;
        font-family: 'Montserrat', sans-serif;
      }

      .pmy-share-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 14px;
      }

      .pmy-share-title {
        margin: 0;
        font-size: 15px;
        line-height: 1.2;
        font-weight: 800;
        color: #173d22;
      }

      .pmy-share-close {
        width: 32px;
        height: 32px;
        border: 0;
        border-radius: 50%;
        display: grid;
        place-items: center;
        background: rgba(0,102,0,.06);
        color: #173d22;
        cursor: pointer;
        font-size: 20px;
        line-height: 1;
      }

      .pmy-share-actions {
        display: grid;
        grid-template-columns: repeat(4, minmax(0,1fr));
        gap: 8px;
      }

      .pmy-share-action {
        border: 0;
        background: transparent;
        color: #173d22;
        padding: 4px 2px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 7px;
        cursor: pointer;
        font: inherit;
        min-width: 0;
      }

      .pmy-share-icon {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        display: grid;
        place-items: center;
        background: #fff;
        border: 1px solid rgba(23,61,34,.12);
        box-shadow: 0 5px 14px rgba(0,0,0,.05);
        transition: transform .18s ease, border-color .18s ease, background .18s ease;
      }

      .pmy-share-action:hover .pmy-share-icon,
      .pmy-share-action:focus-visible .pmy-share-icon {
        transform: translateY(-2px);
        border-color: rgba(0,102,0,.28);
        background: #fbfdfb;
      }

      .pmy-share-icon svg {
        width: 20px;
        height: 20px;
        display: block;
      }

      .pmy-share-label {
        font-size: 11px;
        line-height: 1.15;
        font-weight: 700;
        white-space: nowrap;
      }

      @media (min-width: 768px) {
        .pmy-share-backdrop {
          background: transparent;
          backdrop-filter: none;
          -webkit-backdrop-filter: none;
        }

        .pmy-share-sheet {
          left: auto;
          right: auto;
          bottom: auto;
          width: 350px;
          border-radius: 20px;
          padding: 15px;
        }
      }

      html[data-bs-theme="dark"] .pmy-share-sheet {
        background: rgba(24,32,26,.97);
        border-color: rgba(255,255,255,.12);
        color: #f4f4f1;
      }

      html[data-bs-theme="dark"] .pmy-share-title,
      html[data-bs-theme="dark"] .pmy-share-action,
      html[data-bs-theme="dark"] .pmy-share-close {
        color: #f4f4f1;
      }

      html[data-bs-theme="dark"] .pmy-share-icon,
      html[data-bs-theme="dark"] .pmy-share-close {
        background: rgba(255,255,255,.06);
        border-color: rgba(255,255,255,.14);
      }
    `;
    document.head.appendChild(style);
  }

  function shareIcons(){
    return {
      instagram:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"></rect><circle cx="12" cy="12" r="4"></circle><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"></circle></svg>',
      whatsapp:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.5 11.6a8.5 8.5 0 0 1-12.6 7.4L3 20.5l1.6-4.7a8.5 8.5 0 1 1 15.9-4.2Z"></path><path d="M8.4 7.8c.2-.4.4-.4.7-.4h.5c.2 0 .4.1.5.5l.7 1.7c.1.3.1.5-.1.7l-.6.8c-.2.2-.1.4 0 .6.6 1.1 1.5 2 2.6 2.6.2.1.4.2.6 0l.9-1c.2-.2.4-.2.7-.1l1.7.8c.3.1.5.3.5.5 0 .3-.1 1.4-.8 2-.6.6-1.5.9-2.4.7-1.1-.2-2.6-.7-4.4-2.3-1.5-1.3-2.5-2.9-2.8-4-.3-1-.1-2 .4-2.7Z"></path></svg>',
      facebook:'<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M13.7 22v-8h2.7l.4-3h-3.1V9.1c0-.9.3-1.5 1.6-1.5H17V5c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.4-4 4.1v2H8v3h2.6v8h3.1Z"></path></svg>',
      link:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7-7l-1.1 1.1"></path><path d="M14 11a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7 7l1.1-1.1"></path></svg>'
    };
  }

  function ensureShareLayer(){
    var existing=document.getElementById('pmy-share-layer');
    if(existing) return existing;

    var icons=shareIcons();
    var layer=document.createElement('div');
    layer.id='pmy-share-layer';
    layer.className='pmy-share-layer';
    layer.setAttribute('aria-hidden','true');
    layer.innerHTML=''
      +'<div class="pmy-share-backdrop" data-pmy-share-close></div>'
      +'<div class="pmy-share-sheet" role="dialog" aria-modal="true" aria-label="Share">'
      +  '<div class="pmy-share-head">'
      +    '<p class="pmy-share-title" data-pmy-share-title>Share</p>'
      +    '<button class="pmy-share-close" type="button" aria-label="Close" data-pmy-share-close>&times;</button>'
      +  '</div>'
      +  '<div class="pmy-share-actions">'
      +    '<button class="pmy-share-action" type="button" data-pmy-share="instagram"><span class="pmy-share-icon">'+icons.instagram+'</span><span class="pmy-share-label">Instagram</span></button>'
      +    '<button class="pmy-share-action" type="button" data-pmy-share="whatsapp"><span class="pmy-share-icon">'+icons.whatsapp+'</span><span class="pmy-share-label">WhatsApp</span></button>'
      +    '<button class="pmy-share-action" type="button" data-pmy-share="facebook"><span class="pmy-share-icon">'+icons.facebook+'</span><span class="pmy-share-label">Facebook</span></button>'
      +    '<button class="pmy-share-action" type="button" data-pmy-share="link"><span class="pmy-share-icon">'+icons.link+'</span><span class="pmy-share-label" data-pmy-link-label>Link</span></button>'
      +  '</div>'
      +'</div>';
    document.body.appendChild(layer);

    layer.querySelectorAll('[data-pmy-share-close]').forEach(function(node){
      node.addEventListener('click',closeShareLayer);
    });

    layer.querySelectorAll('[data-pmy-share]').forEach(function(node){
      node.addEventListener('click',function(){
        handleShareAction(node.getAttribute('data-pmy-share'));
      });
    });

    return layer;
  }

  function currentShareData(){
    var layer=document.getElementById('pmy-share-layer');
    return {
      title:(layer && layer.dataset.shareTitle) || document.title,
      url:(layer && layer.dataset.shareUrl) || window.location.href
    };
  }

  function copyLink(url){
    if(navigator.clipboard && navigator.clipboard.writeText){
      return navigator.clipboard.writeText(url);
    }
    return new Promise(function(resolve,reject){
      try{
        var input=document.createElement('textarea');
        input.value=url;
        input.setAttribute('readonly','');
        input.style.position='fixed';
        input.style.opacity='0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
        resolve();
      }catch(err){ reject(err); }
    });
  }

  function trackShare(channel){
    if(Array.isArray(window.dataLayer)){
      window.dataLayer.push({event:'share_tour_click',share_channel:channel,page_location:window.location.href});
    }
  }

  async function handleShareAction(action){
    var data=currentShareData();
    trackShare(action);

    try{
      if(action==='whatsapp'){
        window.open('https://wa.me/?text='+encodeURIComponent(data.title+' '+data.url),'_blank','noopener');
        closeShareLayer();
        return;
      }

      if(action==='facebook'){
        window.open('https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(data.url),'_blank','noopener,width=720,height=560');
        closeShareLayer();
        return;
      }

      if(action==='instagram'){
        if(navigator.share){
          await navigator.share({title:data.title,text:data.title,url:data.url});
          closeShareLayer();
        }else{
          await copyLink(data.url);
          var label=document.querySelector('[data-pmy-link-label]');
          if(label) label.textContent='Copied ✓';
          window.open('https://www.instagram.com/','_blank','noopener');
        }
        return;
      }

      if(action==='link'){
        await copyLink(data.url);
        var copyLabel=document.querySelector('[data-pmy-link-label]');
        if(copyLabel){
          copyLabel.textContent='Copied ✓';
          window.setTimeout(function(){ copyLabel.textContent='Link'; },1600);
        }
      }
    }catch(err){

    }
  }

  function openShareLayer(anchor){
    var layer=ensureShareLayer();
    var titleNode=document.querySelector('.pdp-title');
    var title=(titleNode ? titleNode.textContent.trim() : document.title);
    var url=window.location.href;
    layer.dataset.shareTitle=title;
    layer.dataset.shareUrl=url;

    var heading=layer.querySelector('[data-pmy-share-title]');
    var buttonLabel=anchor ? anchor.textContent.trim() : '';
    if(heading) heading.textContent=buttonLabel || 'Share';

    var linkLabel=layer.querySelector('[data-pmy-link-label]');
    if(linkLabel) linkLabel.textContent='Link';

    layer.classList.add('is-open');
    layer.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';

    if(window.innerWidth>=768 && anchor){
      var sheet=layer.querySelector('.pmy-share-sheet');
      var rect=anchor.getBoundingClientRect();
      window.requestAnimationFrame(function(){
        var width=sheet.offsetWidth;
        var height=sheet.offsetHeight;
        var left=Math.max(16,Math.min(rect.left,window.innerWidth-width-16));
        var top=rect.bottom+10;
        if(top+height>window.innerHeight-16) top=Math.max(16,rect.top-height-10);
        sheet.style.left=left+'px';
        sheet.style.top=top+'px';
      });
    }
  }

  function closeShareLayer(){
    var layer=document.getElementById('pmy-share-layer');
    if(!layer) return;
    layer.classList.remove('is-open');
    layer.setAttribute('aria-hidden','true');
    var sheet=layer.querySelector('.pmy-share-sheet');
    if(sheet){ sheet.style.left=''; sheet.style.top=''; }
    document.body.style.overflow='';
  }

  function initShareExperience(){
    document.addEventListener('click',function(event){
      var target=event.target;
      var button=target && target.closest ? target.closest('.btn-share-tour') : null;
      if(!button) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openShareLayer(button);
    },true);

    document.addEventListener('keydown',function(event){
      if(event.key==='Escape') closeShareLayer();
    });
  }

  ready(function(){
    injectStyles();
    initShareExperience();
  });
})();
